// wijmo
import * as wjCore from "@grapecity/wijmo"
import * as wjcGrid from "@grapecity/wijmo.grid"
import * as wjrGrid from "@grapecity/wijmo.react.grid"
import FlexGridOuter from "../../../components/FlexGridWrapper/FlexGridOuter"
import CONSTANT from "../../../constant"
import { useEffect, useState } from "react"

export type T勤怠日数集計 = {
  出勤日数: number
  休出日数: number
  特休日数: number
  有休日数: number
  振替日数: number
  代休日数: number
  欠勤日数: number
  育介日数: number
  有休残日数: number
}

const SummaryWorkingDayGrid: React.FC<{
  kintaiSummaryData: T勤怠日数集計[]
  isRestoreSearching: boolean
  setIsRestoreSearching: React.Dispatch<React.SetStateAction<boolean>>
}> = (props) => {
  let summaryWorkingDayGridID = "zyomuinSyukkinbo_SummaryWorkingDayGrid"

  const [summaryWorkingDayGrid, setSummaryWorkingDayGrid] =
    useState<wjcGrid.FlexGrid>()
  const [
    summaryWorkingDayGridInitialized,
    setSummaryWorkingDayGridInitialized,
  ] = useState<boolean>(false)

  /**
   * collectionView作成用
   * @param data gridに入れるデータ
   * @param pageSize ページ当たりの行数
   * @returns CollectionView
   */
  const createCollectionView = (data: T勤怠日数集計[]) => {
    return new wjCore.CollectionView(data, {
      calculatedFields: {},
    })
  }

  const [gridData, setGridData] = useState<{
    data: wjCore.CollectionView
  }>({
    data: createCollectionView([]),
  })

  // グリッド初期化時イベントハンドラ
  const SummaryWorkingDayGridInitializedHandler = async (
    grid: wjcGrid.FlexGrid
  ) => {
    // ヘッダーに行追加
    // header行に一行追加
    // 追加行のみ初期化時に設定
    var extraRow = new wjcGrid.Row()
    extraRow.allowMerging = true
    var columnHeaders = grid.columnHeaders
    columnHeaders.rows.splice(0, 0, extraRow)

    columnHeaders.columns.forEach((c, index) => {
      switch (c.binding) {
        case "出勤日数":
        case "休出日数":
        case "特休日数":
        case "有休日数":
        case "振替日数":
        case "代休日数":
        case "欠勤日数":
        case "育介日数":
          columnHeaders.setCellData(0, index, "就労日数")
          break
        default:
          columnHeaders.setCellData(0, index, c.header)
          c.wordWrap = true
          break
      }
      c.allowMerging = true
      c.align = "center"
    })

    // ヘッダの設定
    grid.formatItem.addHandler(summaryFormatItem)
    grid.refresh()
  }

  /**
   * グリッドのフォーマット
   */
  const summaryFormatItem = (
    f: wjcGrid.FlexGrid,
    e: wjcGrid.FormatItemEventArgs
  ) => {}

  useEffect(() => {
    setGridData({ data: createCollectionView(props.kintaiSummaryData) })
  }, [props.kintaiSummaryData])

  useEffect(() => {
    summaryWorkingDayGrid?.refresh()
  }, [gridData, summaryWorkingDayGrid])

  return (
    <FlexGridOuter
      flexGrid={summaryWorkingDayGrid}
      setFlexGrid={setSummaryWorkingDayGrid}
      gridConstantProperties={CONSTANT.GRID.PROPERTY_SET.FLEX_GRID_PROPS_TOTAL}
      gridData={gridData}
      setGridData={setGridData}
      pageNumber={1}
      gridId={summaryWorkingDayGridID}
      isRestoreSearching={props.isRestoreSearching}
      setIsRestoreSearching={props.setIsRestoreSearching}
      gridInitialized={summaryWorkingDayGridInitialized}
      setGridInitialized={setSummaryWorkingDayGridInitialized}
      isShowGridHeader={false}
      isShowGridFooter={false}
      pageSize={0}
      setPageSize={() => {}}
      style={{ maxHeight: "Auto" }}
      gridInitializedHandler={SummaryWorkingDayGridInitializedHandler}
      isShowGridRowPickupButton={false}
      gridProperties={{
        stickyHeaders: false,
      }}
      hasFilter={false}>
      <wjrGrid.FlexGridColumn
        binding="出勤日数"
        isRequired={false}
        isReadOnly={true}
        cssClass={"read-only-cell"}
        width={60}
        header="出勤"></wjrGrid.FlexGridColumn>
      <wjrGrid.FlexGridColumn
        binding="休出日数"
        isRequired={false}
        isReadOnly={true}
        cssClass={"read-only-cell"}
        width={60}
        header="休出"></wjrGrid.FlexGridColumn>
      <wjrGrid.FlexGridColumn
        binding="特休日数"
        isRequired={false}
        isReadOnly={true}
        cssClass={"read-only-cell"}
        width={60}
        header="特休"></wjrGrid.FlexGridColumn>
      <wjrGrid.FlexGridColumn
        binding="有休日数"
        isRequired={false}
        isReadOnly={true}
        cssClass={"read-only-cell"}
        width={60}
        header="有休"></wjrGrid.FlexGridColumn>

      <wjrGrid.FlexGridColumn
        binding="振替日数"
        isRequired={false}
        isReadOnly={true}
        cssClass={"read-only-cell"}
        width={60}
        header="振替"></wjrGrid.FlexGridColumn>
      <wjrGrid.FlexGridColumn
        binding="代休日数"
        isRequired={false}
        isReadOnly={true}
        cssClass={"read-only-cell"}
        width={60}
        header="代休"></wjrGrid.FlexGridColumn>
      <wjrGrid.FlexGridColumn
        binding="欠勤日数"
        isRequired={false}
        isReadOnly={true}
        cssClass={"read-only-cell"}
        width={60}
        header="欠勤"></wjrGrid.FlexGridColumn>
      <wjrGrid.FlexGridColumn
        binding="育介日数"
        isRequired={false}
        isReadOnly={true}
        cssClass={"read-only-cell"}
        width={60}
        header="育介"></wjrGrid.FlexGridColumn>
      <wjrGrid.FlexGridColumn
        binding="有休残日数"
        isRequired={false}
        isReadOnly={true}
        cssClass={"read-only-cell"}
        width={60}
        header="有休残日数"></wjrGrid.FlexGridColumn>
    </FlexGridOuter>
  )
}

export default SummaryWorkingDayGrid
